import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import ModelAddCompany from "./ModalAddCompany";
import ModelViewCompany from "./ModalViewCompany";
import { api } from "../../../utils/Api";
import { useLongPress, LongPressDetectEvents } from "use-long-press";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import ModelCustomPrice from "./ModalCustomPrice";

const table_header = [
  // {
  //   name: "ID",
  //   width: "5",
  // },
  {
    name: "File Name",
    width: "30",
  },
  {
    name: "Estimated Amount",
    width: "20",
  },
  {
    name: "Invoiced Amount",
    width: "10",
  },
  {
    name: "Invoice Paid Amount",
    width: "20",
  },
  {
    name: "Invoice Pending Amount",
    width: "10",
  },
  // {
  //   name: "Pending Amount",
  //   width: "20",
  // },
  {
    name: "Status",
    width: "20",
  },
  {
    name: "",
    width: "5",
  },
];

const filter_data = [
  {
    name: "Orders",
    value: "1",
  },
  {
    name: "Completed Orders",
    value: "2",
  },
  {
    name: "Canceled Orders",
    value: "3",
  },
];

let PageSizeOption = [10, 20, 30, 40, 50];

export default function ViewCompany(props: any) {
  const [id_value, SerIdValue] = useState(useParams());
  const [dashboard_data, SetDashboardData] = useState({});

  const [custom_price_modal, SetCustomPriceModal] = useState({
    is_open: false,
    data: {},
  });
  const [company_data, SetCompanyData] = useState({});
  const [service_data, SetServiceData] = useState({});
  const [table_change_value, SetTableChangeValue] = useState({
    search_filter: "",
    page_number: 1,
    page_size: 10,
    sort_order: true,
    page_no: 1,
    next_page: false,
    filter: 1,
  });
  const [state, setState] = useState({
    notesOpen: false,
    fileOpen: false,
    reworkOpen: false,
    data: {
      active_data: [],
      deleted_data: [],
      service_id: null,
      order_id: null,
    },
  });
  const [selected_data, SetSelectedData] = useState({
    value: "",
    i: "",
  });
  const [side_open, setSideOpen] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [order_data, SetOrderData] = useState([]);
  const [selected_filter, setSelectedFilter] = useState("1");
  const [timer, SetTimer] = useState(null);
  const WAIT_INTERVAL = 700;

  useEffect(() => {
    console.log("View Company on mount:", id_value);
    get_company_info();
    get_orders(table_change_value);
    get_dashborad();
  }, []);

  async function get_dashborad() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
      },
    };
    let data = await api("/outlet/dashboard", pass_data);
    console.log("company dashboard response :", data.response);
    if (data.response.hasOwnProperty("statistics")) {
      SetDashboardData(data.response.statistics);
    }
  }

  async function get_company_info() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
      },
    };
    let data = await api("/outlet/company_info", pass_data);
    console.log("company_info response :", data.response);
    if (data.response.hasOwnProperty("basic_info")) {
      SetCompanyData(data.response.basic_info[0]);
    }
    if (data.response.hasOwnProperty("service_price")) {
      SetServiceData(data.response.service_price);
    }
  }

  async function get_orders(data: any) {
    let count_value, sort_order_value;
    if (data.page_size == "0") {
      count_value = "all";
    } else {
      count_value = data.page_size;
    }
    if (data.sort_order == false) {
      sort_order_value = { column: "id", order: "desc" };
    } else {
      sort_order_value = data.sort_order;
    }
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
        page: data.page_no,
        count: count_value,
        search: data.search_filter,
        // sort: sort_order_value.order,
        // sort_by: sort_order_value.column,
        sort: "desc",
        sort_by: "id",
        filter: data.filter,
      },
    };
    let data_res = await api("/outlet/orders", pass_data);
    console.log("response :", data_res.response);
    SetTableChangeValue((prevValue) => {
      prevValue.next_page = data_res.response.next_page;
      return { ...prevValue };
    });
    if (data_res.response.hasOwnProperty("orders")) {
      SetOrderData(data_res.response.orders);
    } else {
      SetOrderData([]);
    }
  }

  function sample_fun(anchor, open, event) {
    console.log("sample_fun anchor :", anchor);
    console.log("sample_fun open :", open);
    console.log("sample_fun event :", event);
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      console.log("return");
      return;
    }
    console.log("toggle else");

    setSideOpen({ ...state, [anchor]: open });
    // toggleDrawer("bottom", true);
  }

  const list = (anchor) => (
    <div className="mt-3">
      <div className="d-flex justify-content-center">
        <div className="w-25 px-4">
          <hr className="h-3" />
        </div>
      </div>
      <ul className="px-3">
        <li>
          <Link
            className="dropdown-item"
            to={
              "/outlet/" +
              id_value.brand_id +
              "/" +
              id_value.outlet_id +
              "/vieworder/" +
              selected_data.value.id
            }
          >
            <div
              onClick={() => {
                console.log("view");
              }}
            >
              <img
                src={require("../../../assets/icon/svg/eye.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; View
            </div>
          </Link>
        </li>
      </ul>
    </div>
  );

  function title_generate(title: any) {
    let replaced_data = title.replaceAll("_", " ");
    var splitStr = replaced_data.toLowerCase().split(" ");
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }

  function onTextChanged(e: any) {
    clearTimeout(timer);
    const value = e.target.value;
    console.log("Text onchange: ", value);
    SetTableChangeValue((prevValue) => {
      prevValue.search_filter = value;
      if (value == "") {
        get_orders(prevValue);
      } else {
        SetTimer(
          setTimeout(() => {
            get_orders(prevValue);
          }, WAIT_INTERVAL)
        );
      }
      return { ...prevValue };
    });
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4 ">
        <div className="pb-2 d-flex">
          <Link
            to={
              "/outlet/" +
              id_value.brand_id +
              "/" +
              id_value.outlet_id +
              "/company"
            }
          >
            <img
              src={require("../../../assets/icon/svg/arrow-left.svg")}
              className="action-img"
            />
            {/* <button className="btn btn-primary">Back</button> */}
          </Link>
          <h5 className="  ps-2 mb-0 text-dark fw-bolder">View Customer -</h5>
          <p> {company_data.name}</p>
        </div>
        <nav className="pt-1 sticky-tabs">
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className="nav-link active"
              id="dashboard-tab"
              data-bs-toggle="tab"
              data-bs-target="#dashboard"
              type="button"
              role="tab"
              aria-controls="dashboard"
              aria-selected="true"
            >
              Dashboard
            </button>
            <button
              className="nav-link"
              id="info-tab"
              data-bs-toggle="tab"
              data-bs-target="#info"
              type="button"
              role="tab"
              aria-controls="info"
              aria-selected="false"
            >
              Info
            </button>
          </div>
        </nav>
      </div>
      <div className="container tabs-after-container">
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="dashboard"
            role="tabpanel"
            aria-labelledby="dashboard-tab"
          >
            <div className="row">
              {Object.keys(dashboard_data).map((key: any, index: any) => (
                <div className="col-6 col-md-4 col-lg-2" key={index}>
                  <div className="card c-shadow p-3 mb-3">
                    <p className="text-dark pheight">
                      <b>{title_generate(key)}</b>
                    </p>
                    <small className="text-gray">{dashboard_data[key]}</small>
                  </div>
                </div>
              ))}

              {/* <div className="col-md-6 col-lg-3">
                <div className="card c-shadow p-3 mb-3">
                  <h6>Orders</h6>
                  <p>50</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="c-shadow card p-3 mb-3">
                  <h6>Profit</h6>
                  <p>50000</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="c-shadow card p-3 mb-3">
                  <h6>Finished work</h6>
                  <p>40</p>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div className="c-shadow card p-3 mb-3">
                  <h6>pending</h6>
                  <p>10</p>
                </div>
              </div> */}
            </div>

            <div className="card p-3 mt-3">
              <div className="mb-4 mt-2 d-flex">
                <div>
                  <h6 className="mb-1">Files</h6>
                  <small>Customer Files details</small>
                </div>
                <div className="d-flex ms-auto">
                  <Link
                    to={
                      "/outlet/" +
                      id_value.brand_id +
                      "/" +
                      id_value.outlet_id +
                      "/addorder/" +
                      id_value.company_id
                    }
                  >
                    <div className="btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2 ">
                      <img
                        src={require("../../../assets/icon/svg/plus1.svg")}
                        className=""
                      />
                      Add
                    </div>
                  </Link>
                  {/* Filter */}
                  <div>
                    <div className="ms-2 ps-2 cursor dropdown">
                      <button
                        className="btn btn-light-outline btn-sm d-flex"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img
                          src={require("../../../assets/icon/svg/sliders1.svg")}
                          className="acion_menu_img"
                        />
                        <p className="mb-0 text-dark ps-2">Filter</p>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        {filter_data.map((f_ele, f_index) => (
                          <li
                            key={f_index}
                            onClick={() => {
                              SetTableChangeValue((prevValue) => {
                                prevValue.filter = f_ele.value;
                                get_orders(prevValue);
                                return { ...prevValue };
                              });
                              setSelectedFilter(f_ele.value);
                            }}
                            className={
                              selected_filter == f_ele.value
                                ? "filter p-1"
                                : "cursor p-1 text-dark"
                            }
                          >
                            <a className="dropdown-item" href="#">
                              {f_ele.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row pb-3">
                <div className="col-md-8 pb-2">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 pe-2">Show</p>
                    <select
                      className="form-select flex-basis-20"
                      aria-label="Default select example"
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                    <p className="mb-0 ps-2">records per page</p>
                  </div>
                </div>
                <div className="col-md-4 pb-2 text-end">
                  <input
                    type="text"
                    className="form-control"
                    id="staticEmail"
                    placeholder="Search in records..."
                    onChange={(e) => {
                      onTextChanged(e);
                    }}
                  />
                </div>
              </div>

              <div className="d-lg-block d-md-none">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      {table_header.map((head, t_index) => (
                        <th key={t_index}>{head.name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {order_data.length > 0 ? (
                      order_data.map((data, o_index) => (
                        <tr key={o_index}>
                          <td>
                            <p className="mb-1">{data.client_name}</p>
                            <p className="v-small">
                              {data.created_user + "@" + data.created_username}
                            </p>
                          </td>
                          {/* <td>{data.total_amount}</td> */}
                          <td>{data.total_estimated_amount}</td>
                          {/* <td>{data.pending_amount}</td> */}
                          <td>{data.total_invoiced_amount}</td>
                          <td>{data.paid_amount}</td>

                          <td>{data.total_invoice_pending_amount}</td>

                          <td>{data.order_status}</td>
                          <td className="dropdown cursor">
                            <div
                              id="dropdownMenuButton1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <img
                                src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                className="action_img cursor"
                              />
                            </div>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton2"
                            >
                              <li>
                                <Link
                                  className="dropdown-item"
                                  to={
                                    "/outlet/" +
                                    id_value.brand_id +
                                    "/" +
                                    id_value.outlet_id +
                                    "/vieworder/" +
                                    data.id
                                  }
                                >
                                  <div
                                    onClick={() => {
                                      console.log("view");
                                    }}
                                    style={{ marginRight: "5px" }}
                                  >
                                    <img
                                      src={require("../../../assets/icon/svg/eye.svg")}
                                      className="action_menu_img cursor"
                                    />
                                    &nbsp; View
                                  </div>
                                </Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <div className="text-center w-100">
                        <img
                          src={require("../../../assets/img/svg/no_data_2.svg")}
                          className="pb-2"
                        />
                        <p className="v-small mb-0">
                          No{" "}
                          {selected_filter == "1"
                            ? "Orders Placed"
                            : selected_filter == "2"
                            ? "Completed Orders"
                            : "Cancelled Orders"}
                        </p>
                      </div>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-lg-none">
                {order_data.map((data, o_index) => (
                  <div
                    className="row mb-2 border-bottom"
                    key={o_index}
                    onClick={(event) => {
                      sample_fun("bottom", true, event);
                      console.log("bottom sheet open");
                      SetSelectedData({
                        value: data,
                        i: o_index,
                      });
                    }}
                  >
                    <div className="col-12">
                      <h6 className="mb-1">{data.client_name}</h6>
                      <p className="v-small">
                        {data.created_user + "@" + data.created_username}
                      </p>
                    </div>

                    <div className="col-12 d-flex">
                      <p className="v-small">Invoiced Amount :</p>
                      <p className="v-small ms-1">
                        {data.total_invoiced_amount}
                      </p>
                    </div>

                    <div className="col-12 d-flex">
                      <p className="v-small">Invoiced Pending Amount :</p>
                      <p className="v1-small ms-1 text-red">
                        - {data.total_invoice_pending_amount}
                      </p>
                    </div>

                    <div className="col-6">
                      <p>{data.order_status}</p>
                    </div>
                    <div className="col-6 text-end">
                      <h6>
                        <i className="fas fa-rupee-sign"></i>
                        {data.total_amount}
                      </h6>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex align-items-center justify-content-end pe-3 py-2">
                {table_change_value.page_no != 1 ? (
                  <button
                    type="button"
                    className="page-link br-1"
                    onClick={() => {
                      SetTableChangeValue((prevValue) => {
                        prevValue.page_no = prevValue.page_no - 1;
                        get_orders(table_change_value);
                        return { ...prevValue };
                      });
                    }}
                  >
                    Previous
                  </button>
                ) : null}
                {table_change_value.next_page ? (
                  <button
                    type="button"
                    className="page-link br-1"
                    onClick={() => {
                      SetTableChangeValue((prevValue) => {
                        prevValue.page_no = prevValue.page_no + 1;
                        get_orders(table_change_value);
                        return { ...prevValue };
                      });
                    }}
                  >
                    Next
                  </button>
                ) : null}
              </div>
            </div>
          </div>
          {/* Company info*/}
          <div
            className="tab-pane fade"
            id="info"
            role="tabpanel"
            aria-labelledby="info-tab"
          >
            <div className="card px-4 py-3 mb-3">
              <h6>Customer Details</h6>
              <div className="mt-3">
                <p className="fw-bold text-dark mb-1">{company_data.name}</p>

                <p className="v-small text-dark">{company_data.address}</p>

                <div className="row align-items-center my-2">
                  <div className="col-md-6">
                    <p className="mb-0">{company_data.gstin}</p>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <small>{company_data.email}</small>
                  </div>
                </div>
                <div className="row align-items-center my-2">
                  <div className="col-md-6">
                    <p className="mt-1">
                      <i className="fas fa-mobile-alt"></i>
                      {" " + company_data.mobile}
                    </p>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <p className="mt-1">
                      <i className="fab fa-whatsapp"></i>{" "}
                      {" " + company_data.whatsapp}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="card px-4 py-3 mb-3">
              <div className="row align-items-center">
                <div className="col-6">
                  <h6>Custom Service Price</h6>
                </div>
                <div className="col-6 text-end">
                  <div
                    className="text-dark fw-bold cursor"
                    onClick={() => {
                      SetCustomPriceModal({
                        is_open: true,
                        data: service_data,
                      });
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/edit3-1.svg")}
                      className="action-img pe-2"
                    />
                    Edit
                  </div>
                </div>
              </div>

              <div className="row pt-2">
                {Object.keys(service_data).map((key, key_index) => (
                  <div className="col-md-6 col-lg-4 my-3" key={key_index}>
                    {key == "type_1" ? (
                      <h6>Image</h6>
                    ) : key == "type_2" ? (
                      <h6>Video</h6>
                    ) : (
                      <h6>Audio</h6>
                    )}
                    {/* {service_data[key].length > 0 ? ( */}
                    <div className="accordion mt-3" id={"accordion" + key}>
                      {service_data[key].map((ele, ele_index) =>
                        ele.total_price > 0 ? (
                          <div className="accordion-item" key={ele_index}>
                            <div
                              className="accordion-header"
                              id={"heading" + key + ele_index}
                            >
                              <div
                                className="accordion-button cursor"
                                data-bs-toggle="collapse"
                                data-bs-target={"#collapse" + key + ele_index}
                                aria-expanded="true"
                                aria-controls={"collapse" + key + ele_index}
                              >
                                <div className="row">
                                  <h6 className="col-12">{ele.name}</h6>
                                  <p className="col-6 mb-0">
                                    Defalut price{" "}
                                    <span className="fw-bold text-dark">
                                      ₹{ele.default_price}
                                    </span>
                                  </p>
                                  <p className="col-6 mb-0 text-end">
                                    Custom Price{" "}
                                    <span className="fw-bold text-dark">
                                      ₹{ele.price}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div
                              id={"collapse" + key + ele_index}
                              className="accordion-collapse collapse show"
                              aria-labelledby={"heading" + key + ele_index}
                              data-bs-parent={"#accordion" + key}
                            >
                              <div className="accordion-body">
                                {ele.task.length === 0 ? (
                                  <p>No Service Tasks </p>
                                ) : (
                                  <>
                                    <p>Service Tasks</p>
                                    {ele.task.map((task_ele, task_index) => (
                                      <div className="pt-2" key={task_index}>
                                        <h6>{task_ele.name}</h6>
                                        <div className="row">
                                          <div className="col-6">
                                            <p className="text-gray">
                                              Defalut Price{" "}
                                              <span className="fw-bold text-dark">
                                                ₹{task_ele.default_price}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-6 text-end">
                                            <p className="text-gray">
                                              Custom Price{" "}
                                              <span className="fw-bold text-dark">
                                                ₹{task_ele.price}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center" key={ele_index}>
                            <img
                              src={require("../../../assets/img/svg/no_data_2.svg")}
                              className="w-30 pb-2"
                            />
                            <p className="v-small mb-0">
                              {ele.name} Have No Price, Please Add Custom
                              Service Price
                            </p>
                          </div>
                        )
                      )}
                    </div>
                    {/* ) : (
                      <div className="text-center">
                        <img
                          src={require("../../../assets/img/svg/no_data_2.svg")}
                          className="w-30 pb-2"
                        />
                        <p className="v-small mb-0">
                          No Data, Please Add Custom Service Price
                        </p>
                      </div>
                    )} */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModelCustomPrice
        open={custom_price_modal.is_open}
        data={custom_price_modal.data}
        close={(data) => {
          console.log("ModelCustomPrice on close :", data);
          SetCustomPriceModal({
            is_open: false,
            data: {},
          });
          if (data.action == "save") {
            SetServiceData(data.value);
          }
        }}
      />

      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={side_open[anchor]}
            onClose={(event) => {
              sample_fun(anchor, false, event);
            }}
            onOpen={(event) => {
              sample_fun(anchor, true, event);
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
